import React, { useState } from "react";
import { API } from "./../../config/api";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
export default function Contact() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("phone", form.phone);
      formData.append("subject", form.subject);
      formData.append("message", form.message);

      const res = await fetch(API.CONTACT, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Message Sent Successfully!");

        // Reset Form
        setForm({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });

        // 🔥 Refresh Page After 500ms
        setTimeout(() => {
          alert("Message Sent Successfully!");
        }, 500);
      } else {
        alert("Failed to send message");
      }
    } catch (error) {
      console.error(error);
      alert("Server Error");
    }
  };
  return (
    <div className="container-fluid contact-page">
      <div className="row">
        {/* 🔥 LEFT (CONTACT FORM) */}
        <div className="col-lg-12">
          <div className="contact-container" data-aos="fade-up">
            <div className="contact-row">
              {/* LEFT INFO */}
              <div className="contact-left" data-aos="fade-right">
                <h2>Contact Us</h2>
                <p>We’re here to help you anytime.</p>

                <div
                  className="contact-info"
                  data-aos="fade-right"
                  data-aos-delay="0"
                >
                  <h5>
                    <i className="bi bi-geo-alt-fill"></i> Address
                  </h5>
                  <p>
                    {" "}
                    Shop-17, UP GR Floor, Ranuja Complex, Nr- Riddhi Siddhi
                    School, Vallabhacharya Road, Ashvani Kumar, Surat-395008
                    Gujarat, India
                  </p>
                </div>

                <div
                  className="contact-info"
                  data-aos="fade-right"
                  data-aos-delay="100"
                >
                  <h5>
                    <i className="bi bi-telephone-fill"></i> Mobile Number
                  </h5>
                  <p> 9909614445 / 9879196990</p>
                </div>

                <div
                  className="contact-info"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <h5>
                    <i className="bi bi-envelope-fill"></i> Email
                  </h5>
                  <p>embroiderybazar05@gmail.com</p>
                </div>

                <div
                  className="contact-info"
                  data-aos="fade-right"
                  data-aos-delay="300"
                >
                  <h5>
                    <i className="bi bi-clock-fill"></i> Hours
                  </h5>
                  <p>Mon - Sat: 9 AM - 7 PM</p>
                </div>
              </div>

              {/* RIGHT FORM */}
              <div className="contact-right">
                <h4>Send Message</h4>

                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    onChange={handleChange}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    onChange={handleChange}
                    data-aos="fade-up"
                    data-aos-delay="200"
                    required
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Mobile Number"
                    pattern="[0-9]{10}"
                    title="Enter Mobile number"
                    value={form.phone}
                    onChange={handleChange}
                    data-aos="fade-up"
                    data-aos-delay="300"
                    required
                  />
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    onChange={handleChange}
                    data-aos="fade-up"
                    data-aos-delay="400"
                  />
                  <textarea
                    name="message"
                    placeholder="Your Message"
                    onChange={handleChange}
                    required
                    data-aos="fade-up"
                    data-aos-delay="500"
                  ></textarea>

                  <button className="btn-submit">Send Message</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <HorizontalAds />
      </div>
    </div>
  );
}
